/* MCD Pixel-Glitch v3 (13.07.2026, Jonas-Wahl aus dem Cursor-Lab, 2 unabhaengige
   Subagenten-Entwuerfe). Komplett-Neubau gegen das Lag der v2: EIN fixed
   Overlay-Canvas, vorallokierter Partikel-Pool (kein DOM-Spam, keine WAAPI),
   rAF laeuft NUR solange Partikel leben, Fragmente klein (3-14px, Jonas-Tuning).
   Shards ziehen echte Pixel aus den Seiten-Fotos (opts.sources), Ausschnitt
   folgt der Cursor-Position. RGB-Split via Kanal-Multiply auf Offscreen-Kachel
   (kein ctx.filter, kein getImageData). CTA-Explosion = unveraenderter
   Raster-Wipe. Nur Desktop (hover), nie bei reduced-motion. */
window.MCDGlitch = (function () {
  const reduce = matchMedia("(prefers-reduced-motion: reduce)").matches;
  const touch = matchMedia("(hover:none)").matches;
  const clamp = (v, a, b) => Math.min(b, Math.max(a, v));

  function init(opts) {
    opts = opts || {};
    const api = { pixelBoom: (x, y, mid) => { mid && mid(); } };
    if (reduce) return api;

    /* ===== Partikel-Engine (Desktop) ===== */
    if (!touch) (function engine() {
      const cv = document.createElement("canvas");
      cv.className = "gfx"; cv.setAttribute("aria-hidden", "true");
      document.body.appendChild(cv);
      const ctx = cv.getContext("2d");
      let W = 1, H = 1, dpr = 1;
      function measure() {
        W = cv.clientWidth || innerWidth || 1;
        H = cv.clientHeight || innerHeight || 1;
        dpr = devicePixelRatio || 1;
        cv.width = Math.max(2, Math.round(W * dpr));
        cv.height = Math.max(2, Math.round(H * dpr));
      }
      measure();

      /* Quellbilder erst im Leerlauf laden (sind eh im HTTP-Cache der Seite) */
      const srcs = [];
      if (opts.sources && opts.sources.length) {
        addEventListener("load", () => setTimeout(() => {
          opts.sources.forEach(u => {
            const im = new Image();
            im.decoding = "async";
            im.onload = () => srcs.push(im);
            im.src = u;
          });
        }, 800));
      }

      /* einmalige Offscreen-Kachel fuer den RGB-Kanal-Split */
      const TILE = 64;
      const tile = document.createElement("canvas"); tile.width = TILE; tile.height = TILE;
      const tctx = tile.getContext("2d");

      const MAX = 90, pool = new Array(MAX);
      for (let i = 0; i < MAX; i++) pool[i] = { a: false, x: 0, y: 0, vx: 0, vy: 0, life: 0, max: 1, size: 8, ar: 1, img: null, sx: 0, sy: 0, ss: 16, pow: 0, full: false, seed: 0 };
      let active = 0, wr = 0, fc = 0;

      function pick() {
        for (let k = 0; k < MAX; k++) { const j = (wr + k) % MAX; if (!pool[j].a) { wr = (j + 1) % MAX; return pool[j]; } }
        const p = pool[wr]; wr = (wr + 1) % MAX; return p;
      }
      function spawn(x, y, pow) {
        const p = pick(); if (!p.a) active++; p.a = true;
        p.x = x; p.y = y;
        p.max = 0.3 + Math.random() * 0.9; p.life = p.max;
        p.pow = pow;
        p.size = 3 + Math.random() * 5 + pow * 3; /* klein (Jonas 13.07.) */
        p.ar = 0.7 + Math.random() * 0.6;
        const ang = Math.random() * 6.283, sp = (20 + Math.random() * 60) * pow;
        p.vx = Math.cos(ang) * sp; p.vy = Math.sin(ang) * sp;
        p.seed = (Math.random() * 255) | 0;
        p.img = null; p.full = false;
        if (srcs.length) {
          const im = srcs[(Math.random() * srcs.length) | 0];
          const iw = (im && (im.naturalWidth || im.width)) || 0, ih = (im && (im.naturalHeight || im.height)) || 0;
          if (iw > 0 && ih > 0) {
            p.img = im;
            p.ss = Math.min(Math.max(8, p.size * 2), iw, ih);
            /* Ausschnitt folgt der Cursor-Position im Bild — wirkt wie ein oertlicher Riss */
            p.sx = clamp((x / W) * iw - p.ss / 2 + (Math.random() - .5) * 36, 0, iw - p.ss);
            p.sy = clamp((y / H) * ih - p.ss / 2 + (Math.random() - .5) * 36, 0, ih - p.ss);
            p.full = pow > 0.85;
          }
        }
      }

      function draw(p) {
        const t = p.life / p.max;
        let a = (t > 0.8) ? (1 - t) / 0.2 : (t < 0.25 ? t / 0.25 : 1);
        if (a <= 0) return;
        const fl = ((p.seed * 13 + fc * 11) & 15);        /* Flicker */
        if (fl === 0) return;                              /* Dropout-Frame */
        if (fl === 1) a *= 0.45;
        const w = p.size, h = p.size * p.ar, hx = w / 2, hy = h / 2;
        ctx.globalCompositeOperation = "source-over";
        if (p.img) {
          const bands = 3, bh = h / bands, sbh = p.ss / bands;
          for (let b = 0; b < bands; b++) {
            const off = ((p.seed + b * 5 + fc) & 3) - 1.5;  /* Zeilen-Versatz */
            ctx.globalAlpha = a;
            ctx.drawImage(p.img, p.sx, p.sy + b * sbh, p.ss, sbh, p.x - hx + off, p.y - hy + b * bh, w, bh + 0.6);
          }
          if (p.full) {                                    /* RGB-Split via Kanal-Multiply */
            const split = 1 + p.pow * 1.6;
            tctx.globalCompositeOperation = "source-over"; tctx.clearRect(0, 0, TILE, TILE);
            tctx.drawImage(p.img, p.sx, p.sy, p.ss, p.ss, 0, 0, TILE, TILE);
            tctx.globalCompositeOperation = "multiply"; tctx.fillStyle = "#ff0000"; tctx.fillRect(0, 0, TILE, TILE);
            ctx.globalCompositeOperation = "lighter"; ctx.globalAlpha = a * 0.55;
            ctx.drawImage(tile, 0, 0, TILE, TILE, p.x - hx + split, p.y - hy, w, h);
            tctx.globalCompositeOperation = "source-over"; tctx.clearRect(0, 0, TILE, TILE);
            tctx.drawImage(p.img, p.sx, p.sy, p.ss, p.ss, 0, 0, TILE, TILE);
            tctx.globalCompositeOperation = "multiply"; tctx.fillStyle = "#00ffff"; tctx.fillRect(0, 0, TILE, TILE);
            ctx.drawImage(tile, 0, 0, TILE, TILE, p.x - hx - split, p.y - hy, w, h);
            ctx.globalCompositeOperation = "source-over";
          }
        } else {
          ctx.globalAlpha = a * 0.85; ctx.fillStyle = (p.seed & 7) < 5 ? "#1FB3AA" : "#E23A2E";
          ctx.fillRect(p.x - hx, p.y - hy, w, h);
        }
        if ((p.seed & 7) === 0) {                          /* sparsame Teal-Scankante */
          ctx.globalCompositeOperation = "lighter"; ctx.globalAlpha = a * 0.6; ctx.fillStyle = "#7EE8E2";
          ctx.fillRect(p.x - hx, p.y - hy, w, 1);
          ctx.globalCompositeOperation = "source-over";
        }
      }

      let running = false, raf = 0, last = 0;
      let lx = -1, ly = -1, lt = 0;

      function loop(now) {
        if (!running) return;
        let dt = (now - last) / 1000; last = now; if (dt > 0.05) dt = 0.05; if (dt < 0) dt = 0;
        fc++;
        const fr = Math.exp(-3.2 * dt);                    /* framerate-unabhaengige Reibung */
        ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
        ctx.clearRect(0, 0, W, H);
        ctx.globalCompositeOperation = "source-over";
        for (let i = 0; i < MAX; i++) {
          const p = pool[i]; if (!p.a) continue;
          p.life -= dt; if (p.life <= 0) { p.a = false; active--; continue; }
          p.x += p.vx * dt; p.y += p.vy * dt; p.vx *= fr; p.vy *= fr;
          draw(p);
        }
        ctx.globalAlpha = 1; ctx.globalCompositeOperation = "source-over";
        if (active <= 0) { stopLoop(); return; }           /* Loop schlaeft, wenn leer */
        raf = requestAnimationFrame(loop);
      }
      function ensure() { if (running) return; running = true; last = performance.now(); raf = requestAnimationFrame(loop); }
      function stopLoop() { running = false; if (raf) cancelAnimationFrame(raf); raf = 0; ctx.setTransform(1, 0, 0, 1, 0, 0); ctx.clearRect(0, 0, cv.width, cv.height); }

      addEventListener("pointermove", e => {
        const now = e.timeStamp || performance.now(), cx = e.clientX, cy = e.clientY;
        if (lx < 0) { lx = cx; ly = cy; lt = now; return; }
        const dx = cx - lx, dy = cy - ly, dist = Math.hypot(dx, dy);
        if (dist < 3) return;
        const dtm = Math.max(1, now - lt);
        const pow = clamp((dist / dtm) * 0.9 + 0.2, 0.25, 2.2); /* Geschwindigkeit = Energie */
        const n = 1 + Math.min(5, (dist / 14) | 0);
        const dirx = dx / dist, diry = dy / dist;
        for (let s = 0; s < n; s++) {
          const back = s * (7 + Math.random() * 10);
          spawn(cx - dirx * back + (Math.random() - .5) * 16, cy - diry * back + (Math.random() - .5) * 16, pow);
        }
        lx = cx; ly = cy; lt = now; ensure();
      }, { passive: true });
      addEventListener("pointerdown", e => {
        for (let s = 0; s < 12; s++) { const an = Math.random() * 6.283, r = 4 + Math.random() * 30; spawn(e.clientX + Math.cos(an) * r, e.clientY + Math.sin(an) * r, 1.6); }
        ensure();
      }, { passive: true });
      document.addEventListener("visibilitychange", () => { if (document.hidden) stopLoop(); else if (active > 0) ensure(); });
      addEventListener("resize", measure, { passive: true });
    })();

    /* ===== Pixel-Explosion bei CTA-Klick: Raster-Wipe (abgenommener Prototyp-Fallback) ===== */
    if (opts.boom) {
      const wipe = document.createElement("div"); wipe.className = "wipe"; wipe.setAttribute("aria-hidden", "true");
      const wipeCells = [];
      for (let i = 0; i < 24 * 14; i++) {
        const c = document.createElement("i");
        const r = Math.random();
        c.style.background = r < .8 ? "#0B0D0E" : (r < .93 ? "rgba(31,179,170,.32)" : "rgba(226,58,46,.5)");
        wipe.appendChild(c); wipeCells.push(c);
      }
      document.body.appendChild(wipe);
      let booming = false;
      api.pixelBoom = function (clickX, clickY, mid) {
        if (booming) { mid(); return; }
        booming = true;
        wipeCells.forEach(c => { c.style.transition = "none"; c.style.opacity = "0"; });
        requestAnimationFrame(() => requestAnimationFrame(() => {
          wipeCells.forEach(c => { c.style.transition = `opacity .12s steps(2) ${(Math.random() * .26).toFixed(2)}s`; c.style.opacity = "1"; });
          setTimeout(() => { mid(); setTimeout(() => {
            wipeCells.forEach(c => { c.style.transition = `opacity .14s steps(2) ${(Math.random() * .3).toFixed(2)}s`; c.style.opacity = "0"; });
            setTimeout(() => { booming = false; }, 560);
          }, 120); }, 440);
        }));
      };
    }
    return api;
  }
  return { init };
})();
